module.exports = __webpack_public_path__ + "img/hr-level3addon_idle_gun.1b8b6c2a.png";